module.exports = __webpack_public_path__ + "static/media/tech-icon-dinnertime.6f38dfa8.svg";